import { CalendarClock, Bell, PhoneMissed } from "lucide-react";

const automations = [
  {
    icon: CalendarClock,
    title: "Agenda y confirmaciones (opcional)",
    lines: [
      "Si el software lo permite, se puede integrar para confirmar citas.",
      "Si no, se puede usar una agenda paralela (p.ej. Google Calendar).",
    ],
  },
  {
    icon: Bell,
    title: "Recordatorios automáticos (opcional)",
    lines: [
      "Vacunas / desparasitación / revisiones por WhatsApp/SMS/email.",
      "Basado en API del programa o importación CSV/Excel.",
    ],
  },
  {
    icon: PhoneMissed,
    title: "Recuperación de llamadas perdidas (SMS + WhatsApp)",
    lines: [
      "Si no pueden atender, registra la llamada (si hay caller ID) y envía un SMS con enlace directo a WhatsApp.",
      "Notifica al equipo con contacto y hora (WhatsApp/Telegram/email).",
    ],
    note: "Sujeto al tipo de línea y disponibilidad del número.",
  },
];

export const AdvancedAutomationsSection = () => {
  return (
    <section
      data-testid="advanced-automations-section"
      className="pb-16 md:pb-20"
    >
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-10">
          <h3
            data-testid="advanced-automations-title"
            className="text-xl md:text-2xl font-bold text-foreground tracking-tight mb-2"
          >
            Automatizaciones avanzadas (opcionales)
          </h3>
          <p className="text-sm text-muted-foreground max-w-lg mx-auto">
            Se valoran tras una revisión técnica. Dependen del software y
            procesos actuales de la clínica.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {automations.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                data-testid={`automation-card-${index}`}
                className="bg-white rounded-2xl p-7 shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] border border-border/40"
              >
                <div className="w-10 h-10 rounded-xl bg-secondary flex items-center justify-center mb-4">
                  <Icon className="w-5 h-5 text-primary" strokeWidth={1.5} />
                </div>
                <h4 className="text-base font-semibold text-foreground mb-3 tracking-tight">
                  {item.title}
                </h4>
                <ul className="space-y-2">
                  {item.lines.map((line, i) => (
                    <li
                      key={i}
                      className="text-sm text-muted-foreground leading-relaxed flex gap-2"
                    >
                      <span className="text-primary/40 mt-1 shrink-0">&#8226;</span>
                      <span>{line}</span>
                    </li>
                  ))}
                </ul>
                {item.note && (
                  <p className="text-xs text-muted-foreground/70 mt-3 italic">
                    {item.note}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
